export const NotFound = () => {
  return <h1 data-testid="NotFound">Not Found</h1>;
};
